module.exports = __webpack_public_path__ + "static/media/buy_pay_invoice_5.bdadb3e9.jpg";